import classNames from "classnames";
import { FunctionComponent, memo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretUp, faCaretDown } from "@fortawesome/pro-solid-svg-icons";

import { IProps } from "./anomaly-proportion-change.types";
import "./anomaly-proportion-change.scss";

/**
 * Display the change in the proportion of some value. It will be styled differently depending on whether it increased
 * or decreased.
 * @param props.proportionChange How much the proportion of a tag or other value has increased or descreased.
 * @returns                      Proportion change amount.
 */
const AnomalyProportionChange: FunctionComponent<IProps> = ({ proportionChange }) => {
    const isIncrease = proportionChange > 0;
    return (
        <div
            className={classNames("anomaly-proportion-change", {
                "anomaly-proportion-change--decrease": !isIncrease,
                "anomaly-proportion-change--increase": isIncrease,
            })}
        >
            <FontAwesomeIcon
                fixedWidth={true}
                title={isIncrease ? "Increase" : "Decrease"}
                icon={isIncrease || Math.round(proportionChange * 100) === 0 ? faCaretUp : faCaretDown}
            />
            {Math.round(proportionChange * 100)}%
        </div>
    );
};

export default memo(AnomalyProportionChange);
